import React from 'react'
import { useWindowResizeSensor } from 'oio-react'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'
import MainMenu from 'src/apps/AdminWorkspace/apps/MainMenu'
import ContentViewport from 'src/components/Settings/ContentViewport'
import ProtoColumnB from 'src/components/Settings/ProtoColumnB'
import ProtoColumnC from 'src/components/Settings/ProtoColumnC'
import NotFound from 'src/pages/NotFound'
import ContentHome from './Home'
import ContentInitiativeType from './InitiativeType'
import ContentPages from './Pages'
import ContentManageTypes from './ManageTypes'

const SettingsContent = () => {
   const match = useRouteMatch()
   const { currentBreakpoint } = useWindowResizeSensor()
   const currentModeHasThreeColumns = currentBreakpoint > 'd'

   return (
      <ContentViewport>
         <ProtoColumnB>
            <ContentHome />
         </ProtoColumnB>
         <Switch>
            {currentModeHasThreeColumns && (
               <Redirect
                  exact
                  from={match.url}
                  to={`${match.url}/main-menu`}
               />
            )}
            <Route
               path={[
                  `${match.url}/initiativeType`,
                  `${match.url}/main-menu`,
                  `${match.url}/manage-content-types`,
                  `${match.url}/pages`
               ]}
               render={() => (
                  <ProtoColumnC>
                     <Switch>
                        <Route
                           path={`${match.url}/initiativeType/:initiativeTypeId`}
                           component={ContentInitiativeType}
                        />
                        <Route path={`${match.url}/main-menu`}>
                           <MainMenu
                              returnLinkName="Content & Pages"
                              returnLinkTo={match.url}
                           />
                        </Route>
                        <Route
                           path={`${match.url}/manage-content-types`}
                           component={ContentManageTypes}
                        />
                        <Redirect
                           exact
                           from={`${match.url}/pages`}
                           to={`${match.url}/pages/unpublished`}
                        />
                        <Route
                           path={`${match.url}/pages/:pageStatus`}
                           component={ContentPages}
                        />
                     </Switch>
                  </ProtoColumnC>
               )}
            />
            <Route
               path={`${match.url}/:invalid`}
               component={NotFound}
            />
         </Switch>
      </ContentViewport>
   )
}

export default SettingsContent
